export const DeleteMappingModalContent = ({
  tableName,
  tableAddress,
}: {
  tableName: string;
  tableAddress: string;
}) => {
  return (
    <div className="flex flex-col py-2 px-3 gap-1 min-w-0">
      <p className="label-2-semibold text-primary">
        표 범위 재등록 시, 기존 매핑 내역은 삭제됩니다.
      </p>
      <div className="flex flex-col">
        <p className="caption-2-regular text-primary whitespace-pre-wrap min-w-0">
          {`재등록을 위해 표 범위를 변경하면 기존에 작업했던 매핑 내용은 전부 삭제됩니다.`}
        </p>
        <p className="caption-2-regular text-red-600 whitespace-pre-wrap min-w-0">
          삭제 후 재등록을 진행합니다.
        </p>
      </div>
      <OriginalTableInfo tableName={tableName} tableAddress={tableAddress} />
    </div>
  );
};
export const TableReRegisterModalContent = ({
  tableName,
  tableAddress,
}: {
  tableName: string;
  tableAddress: string;
}) => {
  return (
    <div className="flex flex-col py-2 px-3 gap-1 min-w-0">
      <p className="label-2-semibold text-primary">
        셀 위치 변동이 감지되었습니다.
      </p>
      <p className="caption-2-regular text-primary whitespace-pre-wrap min-w-0">
        {`현재 선택한 셀이 기존 위치에서 벗어났습니다. 해당 표의 행/열 삽입, 다른 표의 수정으로 인해 위치가 전반적으로 다 밀렸을 가능성이 있습니다.\n\n표 범위 재등록 후 매핑을 처음부터 진행하세요.`}
      </p>
      <OriginalTableInfo tableName={tableName} tableAddress={tableAddress} />
    </div>
  );
};
export const OriginalTableInfo = ({
  tableName,
  tableAddress,
}: {
  tableName: string;
  tableAddress: string;
}) => {
  return (
    <div className="flex flex-col py-[6px] gap-2 w-full max-w-full bg-[#fafafa] rounded-[6px] min-w-0">
      <div className="flex flex-col px-2 gap-1 min-w-0">
        <p className="caption-2-regular text-primary opacity-[0.66]">
          테이블 이름
        </p>
        <p className="caption-2-semibold text-primary overflow-hidden text-ellipsis whitespace-nowrap max-w-full">
          {tableName}
        </p>
      </div>
      <div className="flex flex-col px-2 gap-1 min-w-0">
        <p className="caption-2-regular text-primary opacity-[0.66]">
          기존 표 범위
        </p>
        <p className="caption-2-semibold text-primary overflow-hidden text-ellipsis whitespace-nowrap max-w-full">
          {tableAddress}
        </p>
      </div>
    </div>
  );
};
